import { Component, Event, EventEmitter, Fragment, getMode, h, Prop } from '@stencil/core';
import { Labels, translate } from '../../../../../utils/translations';

export interface ContactUsConfig {
  enabled: boolean;
  title?: string;
  link?: {
    enabled: boolean;
    url?: string;
    openInNewTab?: boolean;
  };
  phone?: {
    enabled: boolean;
    number: string;
    title: string;
    subTitle: string;
  };
  mail?: {
    enabled: boolean;
    address: string;
    title: string;
    subTitle: string;
  };
  chat?: {
    enabled: boolean;
    title: string;
    subTitle: string;
    available?: boolean;
  };
}

@Component({
  tag: 'ds-header-mobile-contact-us',
  styleUrls: {
    default: 'ds-header-mobile-contact-us.scss',
    light: 'ds-header-mobile-contact-us.scss'
  }
})
export class HeaderMobileContactUs {
  @Prop() open: boolean;
  @Prop() config: ContactUsConfig;

  @Event({ bubbles: false }) menuOpenerClick: EventEmitter;
  @Event() cxsdsHeaderOpenChat: EventEmitter;
  @Event() cxsdsHeaderOpenContactUs: EventEmitter;

  private _handleOpenChat() {
    this.open = false;
    this.cxsdsHeaderOpenChat.emit();
  }

  render() {
    const isLink = !!this.config.link?.enabled;
    return this.config?.enabled ? (
      <ds-action-menu
        open={this.open}
        href={isLink ? this.config.link?.url : null}
        openInNewTab={isLink ? this.config.link.openInNewTab : null}
        openerLabel={this.config.title || translate(Labels.ContactUs)}
        onOpenerClick={(e) => {
          if (isLink && !this.config.link.url) {
            e.detail.preventDefault();
            this.cxsdsHeaderOpenContactUs.emit();
          } else if (!isLink) {
            this.menuOpenerClick.emit();
          }
        }}
        data-mode={getMode(this)}
        mobile
      >
        <ds-icon name='Comment' class='contact-us__icon' size='big' slot='opener-content' />
        {!isLink ? (
          <div class='contact-us__dropdown' slot='dropdown-content'>
            <ul class='contact-us__list'>
              <slot name='contact-us' />
              {this.config.phone?.enabled && (
                <Fragment>
                  <li class='contact-us__list-item phone'>
                    <p class='title'>Call us at</p>
                    <ds-link href={`tel:${this.config.phone.number}`} type='secondary'>
                      {this.config.phone.number}
                    </ds-link>
                    <p class='sub-title'>Or see our list of Local Numbers</p>
                  </li>
                  <li class='contact-us__list-item contact'>
                    <ds-link
                      class='contact-us__link'
                      type='inherit'
                      href={`tel:${this.config.phone.number}`}
                    >
                      <div class='icon-placeholder'>
                        <ds-icon name='ContactUsPhone' />
                      </div>
                      <div class='wrapper'>
                        <p class='title'>{this.config.phone.title}</p>
                        <p class='sub-title'>{this.config.phone.subTitle}</p>
                      </div>
                    </ds-link>
                  </li>
                </Fragment>
              )}
              {this.config.mail?.enabled && (
                <li class='contact-us__list-item contact'>
                  <ds-link
                    class='contact-us__link'
                    type='inherit'
                    href={`mailto:${this.config.mail.address}`}
                  >
                    <div class='icon-placeholder'>
                      <ds-icon name='ContactUsMail' />
                    </div>
                    <div class='wrapper'>
                      <p class='title'>{this.config.mail.title}</p>
                      <p class='sub-title'>{this.config.mail.subTitle}</p>
                    </div>
                  </ds-link>
                </li>
              )}
              {this.config.chat?.enabled && (
                <li class='contact-us__list-item contact'>
                  <ds-link
                    class='contact-us__link'
                    type='inherit'
                    onClick={() => this._handleOpenChat()}
                  >
                    <div class='icon-placeholder'>
                      <ds-icon name='ContactUsChat' />
                    </div>
                    <div class='wrapper'>
                      <p class='title'>{this.config.chat.title}</p>
                      <p class='sub-title'>{this.config.chat.subTitle}</p>
                    </div>
                  </ds-link>
                </li>
              )}
            </ul>
          </div>
        ) : null}
      </ds-action-menu>
    ) : null;
  }
}
